export default "__VITE_ASSET__2caedbb9__"